import { UserProfile as AppUserProfile } from '../../types/invitation';
import { supabase } from './client';
import { DBUserProfile } from './types';
import { transformDBUserProfileToApp } from './transforms';
import { createLogger } from '../logger';

const userLog = createLogger('user');

export const userProfileService = {
  async createProfile(userId: string, profileData: { displayName?: string; phone?: string; weddingDate?: string; partnerName?: string }): Promise<string> {
    const { data, error } = await supabase
      .from('user_profiles')
      .insert({
        user_id: userId,
        display_name: profileData.displayName,
        phone: profileData.phone,
        wedding_date: profileData.weddingDate,
        partner_name: profileData.partnerName,
      })
      .select('id')
      .single();

    if (error) throw error;
    return data.id;
  },

  async getProfile(userId: string): Promise<AppUserProfile | null> {
    userLog.debug('開始查詢用戶資料:', userId);

    try {
      userLog.debug('準備執行 Supabase 查詢...');
      const { data, error } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('user_id', userId)
        .maybeSingle();

      userLog.debug('查詢完成，結果:', { hasData: !!data, hasError: !!error });

      if (error) {
        userLog.error('查詢錯誤:', error);
        return null;
      }

      if (!data) {
        userLog.debug('用戶尚未有 profile 記錄');
        return null;
      }

      userLog.debug('找到 profile 資料，準備轉換');
      const result = transformDBUserProfileToApp(data);
      userLog.debug('轉換完成，返回結果');
      return result;
    } catch (error) {
      userLog.error('執行錯誤:', error);
      return null;
    }
  },

  async updateProfile(userId: string, updates: Partial<AppUserProfile>): Promise<void> {
    const dbUpdates: Partial<DBUserProfile> = {};

    if (updates.displayName !== undefined) dbUpdates.display_name = updates.displayName;
    if (updates.phone !== undefined) dbUpdates.phone = updates.phone;
    if (updates.weddingDate !== undefined) dbUpdates.wedding_date = updates.weddingDate;
    if (updates.partnerName !== undefined) dbUpdates.partner_name = updates.partnerName;

    const { error } = await supabase
      .from('user_profiles')
      .update(dbUpdates)
      .eq('user_id', userId);

    if (error) throw error;
  },

  async deleteProfile(userId: string): Promise<void> {
    const { error } = await supabase
      .from('user_profiles')
      .delete()
      .eq('user_id', userId);

    if (error) throw error;
  }
};
